module.exports = __webpack_public_path__ + "media/images/woman-and-boy-on-a-tablet-aa4580af63a33cd87af785758617c341.jpg";